
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as Category8lkloqV07tMeta } from "/app/pages/[_lang]/[_city]/Category.vue?macro=true";
import { default as CoverageLuCJJibWnNMeta } from "/app/pages/[_lang]/[_city]/Coverage.vue?macro=true";
import { default as LeadSG8TvtqQEkMeta } from "/app/pages/[_lang]/[_city]/Lead.vue?macro=true";
import { default as OptionsfMlNssP0a7Meta } from "/app/pages/[_lang]/[_city]/Options.vue?macro=true";
import { default as Personal7OOarx42QGMeta } from "/app/pages/[_lang]/[_city]/Personal.vue?macro=true";
import { default as WidgetZFZYVCCFBGMeta } from "/app/pages/[_lang]/Widget.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as ReferralriFNLzVut2Meta } from "/app/pages/Referral.vue?macro=true";
import { default as Category3RIVYMXMWPMeta } from "/app/pages/webview/[_lang]/[_city]/Category.vue?macro=true";
import { default as CoveragetYqathlD62Meta } from "/app/pages/webview/[_lang]/[_city]/Coverage.vue?macro=true";
import { default as dateBQ5av0olVQMeta } from "/app/pages/webview/[_lang]/[_city]/date.vue?macro=true";
import { default as FinalXheteggFEjMeta } from "/app/pages/webview/[_lang]/[_city]/Final.vue?macro=true";
import { default as Optionscq472te1SzMeta } from "/app/pages/webview/[_lang]/[_city]/Options.vue?macro=true";
import { default as onboardingVUprG0XL9EMeta } from "/app/pages/webview/[_lang]/[_city]/service/onboarding.vue?macro=true";
import { default as selectdqxwQs7uMhMeta } from "/app/pages/webview/[_lang]/[_city]/service/select.vue?macro=true";
import { default as Summaryjg6b4g3qxGMeta } from "/app/pages/webview/[_lang]/[_city]/Summary.vue?macro=true";
export default [
  {
    name: "_lang-_city-Category",
    path: "/:_lang()/:_city()/Category",
    component: () => import("/app/pages/[_lang]/[_city]/Category.vue")
  },
  {
    name: "_lang-_city-Coverage",
    path: "/:_lang()/:_city()/Coverage",
    component: () => import("/app/pages/[_lang]/[_city]/Coverage.vue")
  },
  {
    name: "_lang-_city-Lead",
    path: "/:_lang()/:_city()/Lead",
    component: () => import("/app/pages/[_lang]/[_city]/Lead.vue")
  },
  {
    name: "_lang-_city-Options",
    path: "/:_lang()/:_city()/Options",
    component: () => import("/app/pages/[_lang]/[_city]/Options.vue")
  },
  {
    name: "_lang-_city-Personal",
    path: "/:_lang()/:_city()/Personal",
    component: () => import("/app/pages/[_lang]/[_city]/Personal.vue")
  },
  {
    name: "_lang-Widget",
    path: "/:_lang()/Widget",
    meta: WidgetZFZYVCCFBGMeta || {},
    component: () => import("/app/pages/[_lang]/Widget.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "Referral",
    path: "/Referral",
    component: () => import("/app/pages/Referral.vue")
  },
  {
    name: "webview-_lang-_city-Category",
    path: "/webview/:_lang()/:_city()/Category",
    meta: Category3RIVYMXMWPMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Category.vue")
  },
  {
    name: "webview-_lang-_city-Coverage",
    path: "/webview/:_lang()/:_city()/Coverage",
    meta: CoveragetYqathlD62Meta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Coverage.vue")
  },
  {
    name: "webview-_lang-_city-date",
    path: "/webview/:_lang()/:_city()/date",
    meta: dateBQ5av0olVQMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/date.vue")
  },
  {
    name: "webview-_lang-_city-Final",
    path: "/webview/:_lang()/:_city()/Final",
    meta: FinalXheteggFEjMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Final.vue")
  },
  {
    name: "webview-_lang-_city-Options",
    path: "/webview/:_lang()/:_city()/Options",
    meta: Optionscq472te1SzMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Options.vue")
  },
  {
    name: "webview-_lang-_city-service-onboarding",
    path: "/webview/:_lang()/:_city()/service/onboarding",
    meta: onboardingVUprG0XL9EMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/onboarding.vue")
  },
  {
    name: "webview-_lang-_city-service-select",
    path: "/webview/:_lang()/:_city()/service/select",
    meta: selectdqxwQs7uMhMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/select.vue")
  },
  {
    name: "webview-_lang-_city-Summary",
    path: "/webview/:_lang()/:_city()/Summary",
    meta: Summaryjg6b4g3qxGMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Summary.vue")
  }
]